import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'src/utils/baseAxios';

/* eslint-disable no-param-reassign */

const getErrorMessage = (error, fallback) => error.response?.data?.message
  || error.response?.data?.Message
  || error.response?.data
  || error.message
  || fallback;

export const getRejectByHqWorkOrder = createAsyncThunk(
  'rejectByHq/getWorkOrder',
  async (workOrderNumber, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/RejectByHq/GetWorkOrder/${workOrderNumber}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Work order not found'));
    }
  }
);

export const rejectWorkOrderByHq = createAsyncThunk(
  'rejectByHq/reject',
  async ({ workOrderNumber, reason, documentsCancelled, erpDetailIds }, { rejectWithValue }) => {
    try {
      const response = await axios.post('/RejectByHq/Reject', {
        WorkOrderNumber: Number(workOrderNumber),
        Reason: reason || null,
        DocumentsCancelled: Boolean(documentsCancelled),
        ErpDetailIds: erpDetailIds || ''
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Rejection failed'));
    }
  }
);

const rejectByHqSlice = createSlice({
  name: 'rejectByHq',
  initialState: {
    loading: false,
    actionLoading: false,
    workOrder: null,
    error: '',
    actionSuccess: false,
    actionMessage: ''
  },
  reducers: {
    clearRejectByHqWorkOrder(state) {
      state.workOrder = null;
      state.error = '';
      state.actionSuccess = false;
      state.actionMessage = '';
    },
    clearRejectByHqError(state) {
      state.error = '';
    },
    clearRejectByHqAction(state) {
      state.actionSuccess = false;
      state.actionMessage = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRejectByHqWorkOrder.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getRejectByHqWorkOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.workOrder = action.payload;
        state.error = '';
      })
      .addCase(getRejectByHqWorkOrder.rejected, (state, action) => {
        state.loading = false;
        state.workOrder = null;
        state.error = action.payload || action.error.message;
      })
      .addCase(rejectWorkOrderByHq.pending, (state) => {
        state.actionLoading = true;
        state.actionSuccess = false;
        state.actionMessage = '';
        state.error = '';
      })
      .addCase(rejectWorkOrderByHq.fulfilled, (state, action) => {
        state.actionLoading = false;
        state.actionSuccess = true;
        state.actionMessage = action.payload?.Message || 'Work order rejected successfully';
        if (state.workOrder) {
          state.workOrder.WorkOrderStatus = 'Rejected by HQ';
          state.workOrder.CanReject = false;
          state.workOrder.Documents = [];
          state.workOrder.DocumentCount = 0;
        }
      })
      .addCase(rejectWorkOrderByHq.rejected, (state, action) => {
        state.actionLoading = false;
        state.actionSuccess = false;
        state.error = action.payload || action.error.message;
      });
  }
});

export const {
  clearRejectByHqWorkOrder,
  clearRejectByHqError,
  clearRejectByHqAction
} = rejectByHqSlice.actions;

export default rejectByHqSlice;
